
import { ConversationContext } from "./useA2AContextExtractors";

/**
 * Helper to determine if an agent message is "external" (requires approval)
 */
export function requiresExternalApproval(content: string) {
  const lowered = content.toLowerCase();
  return lowered.includes("email") || lowered.includes("calendar invite") || lowered.includes("calendar event");
}

/**
 * Check if we need more information about entities in the request
 */
export function needsContextualClarification(content: string, context: ConversationContext): string | null {
  const lowered = content.toLowerCase();
  // Check for unknown participants
  if (context.participants?.some(p => !p.known)) {
    return `I notice you're mentioning ${context.participants.find(p => !p.known)?.name}. Since they're not in our system, could you provide their email address or more details about them?`;
  }
  // Check for ambiguous locations
  if (context.location?.needsConfirmation) {
    return `Could you confirm which ${context.location.name} location you're referring to? I see multiple options in ${context.location.name} in Gilbert, AZ.`;
  }
  return null;
}
